"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _configuratorCarousel = _interopRequireDefault(require("../styles/configurator-carousel.css"));

var ProgressButton = function ProgressButton(_ref) {
  var handleChangeSlide = _ref.handleChangeSlide,
      buttonLabel = _ref.buttonLabel,
      carouselImagesLength = _ref.carouselImagesLength,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: buttonLabel,
    "aria-label": buttonLabel,
    onClick: function onClick() {
      return handleChangeSlide();
    },
    disabled: carouselImagesLength === 1,
    className: theme.mmcIconChevronDown + " " + _configuratorCarousel["default"].arrow
  });
};

var _default = ProgressButton;
exports["default"] = _default;